import { render } from "./CourierPricing.vue?vue&type=template&id=45a8d079"
import script from "./CourierPricing.vue?vue&type=script&lang=js"
export * from "./CourierPricing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Functional/CourierPricing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45a8d079"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45a8d079', __exports__)) {
    api.reload('45a8d079', __exports__)
  }
  
  module.hot.accept("./CourierPricing.vue?vue&type=template&id=45a8d079", () => {
    api.rerender('45a8d079', render)
  })

}


export default __exports__